import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAvatar,_vm._b({attrs:{"color":_vm.imageAvatar ? undefined : _vm.generateColorBasedOnId(_vm.value.id)}},'v-avatar',_vm.$attrs,false),[(_vm.imageAvatar)?_c(VImg,[_vm._v("TODO")]):_c('span',{staticClass:"white--text",style:(`font-size: ${_vm.textSize}px !important`)},[_vm._v(_vm._s(_vm.value.name ? _vm.value.name.charAt(0).toUpperCase() : ""))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }